////////////////////////////////////////
// Vendors
////////////////////////////////////////
import $ from 'jquery';
// import fullpage from 'fullpage.js';



////////////////////////////////////////
// Bulb micro Framework
////////////////////////////////////////
import Bulb from "./modules/bulb";
import Utils from "./modules/utils";
import Video from "./modules/video";
import Slider from "./modules/slider";
import SliderAgencies from "./modules/sliderAgencies";
import ChantierFilter from "./modules/chantierFilter";
import MapFranceGdi from "./modules/map-france-gdi";
import ParticlesWave from "./modules/particles-wave";
import HomeImageTransition from "./modules/homeImageTransition";
import VideoPopin from "./modules/videoPopin";
import Historic from "./modules/historic";
import ContactMap from "./modules/contactMap";
import FullPageScroll from './modules/fullPageScroll';
import GoogleMaps from './modules/googleMaps';
import Tooltip from './modules/tooltip'
import SeoSection from './modules/seoSection'
import Counter from './modules/counter'

////////////////////////////////////////
// On configure toutes les vues ici
const HomeView = require('./pages/home').init();



class Website extends Bulb{

		constructor() {
			super();
			this.homePageTransition = false;
		}

    /**
     * Evenements lancé uniquement au lancement du site
     */
    startEvents(){
        Utils.debug('App : startEvents');
    }

		clear(){
			// Gestion de la destruction reconstruction
			this.homePageTransition.destroy();
		}

    /**
     * Evenement lancé à chaque changement de page
     */
    defaultEvents() {
        Utils.debug('App : defaultEvents');

				this.homePageTransition = new HomeImageTransition();
				new ContactMap();
				new GoogleMaps();
        new ChantierFilter();
        new SliderAgencies();
				new FullPageScroll();
				new Historic();
        new Video();
        new Slider();
        new MapFranceGdi();
        new ParticlesWave();
				new VideoPopin();
				new Tooltip();
				new SeoSection();
				new Counter();

				// on remet le menu principal en blacn
				$('.main-menu__btn span').css('background','#fff')



			var wpcf7_form = document.getElementsByClassName('wpcf7-form');
			[].forEach.call(wpcf7_form, function( form ) {
				if(typeof wpcf7 != "undefined"){
					wpcf7.initForm( form );
				}
			});

			if(typeof elementorFrontend !== 'undefined') {
				elementorFrontend.hooks.addAction('frontend/element_ready/widget', function( $scope ) {
					if($scope.data('widget_type') === 'bulb-slider.default'){
						new Slider();
						new SliderAgencies();
					}
				});
			}

		}
}

////////////////////////////////////////
$('document').ready(function () {
    var App = new Website();
    App.startEvents();
    App.defaultEvents();
});


